import { render, staticRenderFns } from "./psp-form.vue?vue&type=template&id=091b8906&scoped=true"
import script from "./psp-form.vue?vue&type=script&lang=js"
export * from "./psp-form.vue?vue&type=script&lang=js"
import style0 from "./psp-form.vue?vue&type=style&index=0&id=091b8906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091b8906",
  null
  
)

export default component.exports